import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router';
import { handleTokenAuthFlow } from '../services/authService';

export default function PrivateRoute() {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const result = await handleTokenAuthFlow();
      setIsAuthenticated(result);
      setAuthChecked(true);
    };
    checkAuth();
  }, []);

  if (!authChecked) return null; // or a loading spinner

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
}
